import Axios from 'axios'
import Domain from 'domain-service'
import Env from 'env-service'

export default function httpFactory(firebaseUser) {
  const http = Axios.create({
    // Axios dispatches requests against the same host (e.g. go.mydomain.com:8888).
    // As all business service APIs are located at the same host as static resource
    // for both staging and production, baseURL only needs to be customised for local environment
    baseURL: Env.IS_LOCAL_CONNECTION ? Domain.decorateWithServicesDomain`` : '',
    // Assume all requests have json payload
    headers: { 'Content-Type': 'application/json' }
    // default setting for timeout is 0, which means Axios do not timeout at all
  })

  // web services
  http.wsaDomain =
    Env.IS_LOCAL_CONNECTION || Env.IS_STAGE_CONNECTION
    ? 'https://staging-wsa.adacado.com'
    : 'https://wsa.adacado.com'

  // inventory service
  http.inventoryDomain =
    Env.IS_LOCAL_CONNECTION || Env.IS_STAGE_CONNECTION
    ? 'https://staging-inventory.adacado.com'
    : 'https://inventory.adacado.com'

  http.interceptors.request.use(
    config => {
      // Always check/refresh Firebase auth id token before making any BS calls,
      // ensuring bearer token is refreshed before BE has to make an authorization check
      // This will fix most 520 errors we've seen from session expires
      // https://firebase.google.com/docs/auth/admin/verify-id-tokens
      // https://github.com/axios/axios/issues/754
      return firebaseUser
        ? firebaseUser.getIdToken().then(token => {
            config.headers.Authorization = `Bearer ${token}`
            return Promise.resolve(config)
          })
        : config
    },
    error => {
      return Promise.reject(error)
    }
  )
  return http
}